export const EN_US = 'en-US';
export const FR_CA = 'fr-CA';
export const ES_419 = 'es-419';